
import {Component, Prop, Vue} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import AuditValueChangeDto = MdbsCore.AuditValueChangeDto;
import {formatDate, formatDateTime} from "@/auxillary/date-format";

@Component({
  components: {},
  filters: {
    formatDate,
    formatDateTime,
  }
})
export default class AuditTrailTable extends Vue {
  @Prop({default: [], required: true}) private changes: AuditValueChangeDto[];
  @Prop({default: false}) private loading: boolean;

  //sort: (d1: Date, d2: Date) => new Date(d1).getTime() > new Date(d2).getTime() ? 1 : -1

  headers = [
    {
      text: 'User',
      value: 'user.userName',
      align: "left",
    },
    {
      text: 'Role',
      value: 'user.roleIdentifier',
      align: "left",
    },
    {
      text: 'Date (GMT)',
      value: 'timeStamp',
      align: "left",
    },
    {
      text: 'Action',
      value: 'action',
      sortable: false,
      align: "left"
    },
    {
      text: 'Type',
      value: 'objectName',
      sortable: false,
      align: "left"
    },
    {
      text: 'Path',
      value: 'valuePath',
      sortable: false,
      align: "left"
    },
    {
      text: 'Old value',
      value: 'oldValue',
      sortable: false,
      align: "left"
    },
    {
      text: 'New value',
      value: 'newValue',
      sortable: false,
      align: "left"
    },
    {
      text: 'Reason of Change',
      value: 'reasonsOfChange',
      sortable: false,
      align: "left"
    }
  ]
}
